import axios from "axios";
import React, { useEffect, useState } from "react";
import { Loader } from "react-bootstrap-typeahead";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import StarIcon from "@mui/icons-material/Star";
import { useGetGeoLocationMutation } from "../../Services/vehicle/Vehicle";
import { toast } from "react-toastify";
import "./WorkshopLocator.scss";

interface IPROPS {
    setStoreGeoLocationData: any;
    storedGeoLoaction: any;
    onClose: () => void;
}

const WorkshopLocator: React.FC<IPROPS> = ({
    setStoreGeoLocationData,
    storedGeoLoaction,
    onClose
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [getWorkshopData, setGetWorkshopData] = useState([]);
    const [workshopId, setWorkshopId] = useState("");
    const [workshopData, setWorkshopData] = useState<any>({});
    const [location, setLocation] = useState("");

    const token = localStorage.getItem("customer-token");
    const fetchingTenant = window.location.hostname.split(".")[0];
    const apiPort = process.env.REACT_APP_API_PROTOCOL;

    const [geoLocationTrigger, { status }] = useGetGeoLocationMutation();

    const getLocation = async (e: any) => {
        e.preventDefault();
        const locationPayload = {
            address: location,
        };
        try {
            const response = await geoLocationTrigger(locationPayload);

            setStoreGeoLocationData(response?.data);
            if (response?.data) {
                toast.success("Location fetched successfully");
            } else if (response?.error) {
                toast.error("unabel to find the location");
            }
        } catch (error) { }
    };

    console.log(storedGeoLoaction, "storedGeoLoaction");

    const fetchWorkshops = async () => {
        const payload = {
            latitude: storedGeoLoaction?.latitude,
            longitude: storedGeoLoaction?.longitude,
            radius_km: 20, // optional, default 10km
        };
        setIsLoading(true);
        try {
            const response = await axios.post(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/garage-search/website-search/`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setGetWorkshopData(response?.data?.data);
        } catch (error) {
            console.error("Error fetching profile:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (storedGeoLoaction) {
        }
        fetchWorkshops();
    }, [storedGeoLoaction]);
    return (
        <div
            className="workshop-locator-modal-container"
            style={{ position: "relative", paddingTop: 48 }}
        >
            <button
                onClick={onClose}
                aria-label="Close"
                style={{
                    position: "absolute", // Ensure the button is absolutely positioned
                    top: 12,
                    right: 20,
                    background: "transparent",
                    border: "none",
                    width: 32,
                    height: 32,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    fontSize: 36,
                    zIndex: 100,
                    fontFamily: 'Karbon-regular',
                 
                }}
            >
                ×
            </button>
            {storedGeoLoaction && (
                <div className="workshop-data">
                    <>
                        {isLoading ? (
                            <div
                                style={{
                                    textAlign: "center",
                                    padding: "20px",
                                    fontSize: "16px",
                                }}
                            >
                                Loading workshops...
                                <Loader />
                            </div>
                        ) : getWorkshopData && getWorkshopData.length > 0 ? (
                            <>
                                <div className="available-workshops-heading"  style={{ textAlign: "center", fontSize: "16px", fontFamily:"karbon-medium" }}>
                                    Available Workshops
                                </div>

                                {getWorkshopData?.map((workshop, index) => (
                                    <div
                                        key={workshop?.id || index}
                                        style={{
                                            borderRadius: "12px",
                                            padding: "16px",
                                            backgroundColor: "#fff",
                                            overflow: "scroll",
                                            boxShadow:
                                                "0 2px 8px rgba(0,0,0,0.1)",
                                            display: "flex",
                                            gap: "16px",
                                            alignItems: "center",
                                            maxWidth: "100%",
                                            border:
                                                workshopId === workshop?.id
                                                    ? "1px solid red"
                                                    : "",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            setWorkshopId(workshop?.id);
                                            setWorkshopData(workshop);
                                        }}
                                    >
                                        <div style={{ flex: 1 }}>
                                            <h3
                                                style={{
                                                    margin: "0",
                                                    fontSize: "18px",
                                                    fontWeight: "600",
                                                    fontFamily:"karbon-medium"
                                                }}
                                            >
                                                {workshop?.name}
                                            </h3>
                                            <p
                                                style={{
                                                    margin: "4px 0",
                                                    fontSize: "14px",
                                                    color: "#555",
                                                    fontFamily:"karbon-regular"
                                                }}
                                            >
                                                {workshop?.address}
                                            </p>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "12px",
                                                    alignItems: "center",
                                                    margin: "4px 0",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        fontSize: "14px",
                                                        color: "#888",
                                                                 fontFamily:"karbon-bold"
                                                    }}
                                                >
                                                    <LocationOnIcon
                                                        fontSize="small"
                                                        style={{
                                                            color: "red",
                                                            marginRight: 4,
                                                          
                                                        }}
                                                    />
                                                    {workshop?.distance_text}
                                                </span>
                                                <span
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        fontSize: "14px",
                                                        color: "#888",
                                                                 fontFamily:"karbon-bold"
                                                    }}
                                                >
                                                    <AccessTimeIcon
                                                        fontSize="small"
                                                        style={{
                                                            color: "#ff9800",
                                                            marginRight: 4,
                                                   
                                                        }}
                                                    />
                                                    {workshop?.duration_text}
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px",
                                                    marginTop: "6px",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        fontSize: "14px",
                                                        color: "#444",
                                                        fontFamily:"karbon-bold"
                                                    }}
                                                >
                                                    <StarIcon
                                                        fontSize="small"
                                                        style={{
                                                            color: "#ffc107",
                                                            marginRight: 4,
                                                           
                                                        }}
                                                    />
                                                    {workshop?.internal_rating}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </>
                        ) : (
                            <div
                                style={{
                                    textAlign: "center",
                                    padding: "20px",
                                    fontSize: "16px",
                                    color: "#777",
                                }}
                            >
                                No workshop found.
                            </div>
                        )}
                    </>
                </div>
            )}
            <div style={{ flex: 1, position: "relative" }}>
                <div
                    style={{
                        display: "flex",
                        gap: 10,
                        marginTop: "0px",
                        marginBottom: "3px"
                    }}
                >
                    <input
                        onChange={(e) => setLocation(e.target.value)}
                        type="text"
                        placeholder="ZIP CODE/PIN CODE"
                        disabled={isLoading}
                        style={{
                            flex: 1,
                            padding: "10px 12px",
                            borderRadius: 4,
                            border: "1px solid #ccc",
                            fontSize: 14,
                            opacity: isLoading ? 0.7 : 1,
                            cursor: isLoading ? 'not-allowed' : 'text',
                            backgroundColor: isLoading ? '#f5f5f5' : 'white'
                        }}
                    />
                    <button
                        onClick={getLocation}
                        disabled={isLoading}
                        style={{
                            background: isLoading ? "#ccc" : "#FF5722",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            padding: "10px 15px",
                            cursor: "pointer",
                            fontWeight: 500,
                            fontFamily:"karbon-semi"
                        }}
                    >
                        <span
                            role="img"
                            aria-label="find"
                            style={{ marginRight: 5, }}
                        >
                            🎯
                        </span>
                        FIND
                    </button>
                </div>

                <iframe
                    title="garage-map"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    src={`https://www.google.com/maps?q=${workshopData?.latitude || 28.6072042
                        },${workshopData?.longitude || 77.3808272
                        }&z=6&output=embed`}
                />
            </div>
        </div>
    );
};

export default WorkshopLocator;
